import './assets/main.scss'

import * as Sentry from '@sentry/vue'
import { createApp } from 'vue'
import { createPinia } from 'pinia'
import VueAwesomePaginate from 'vue-awesome-paginate'
import App from './App.vue'
import router from './router'
import AppReady from './AppReady'
import { createVfm } from 'vue-final-modal'
import 'vue-final-modal/style.css'
import { VueQueryPlugin } from '@tanstack/vue-query'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import Linkify from './directives/Linkify'

const app = createApp(App)

Sentry.init({
  app,
  dsn: 'https://906d3930c018521a8b78612111fb90a1@o4508575487754240.ingest.de.sentry.io/4508840908750928',
  integrations: [Sentry.browserTracingIntegration({ router }), Sentry.replayIntegration()],
  // Tracing
  tracesSampleRate: 0.5, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: [
    'localhost',
    /^https:\/\/api\.baykusmentorluk\.com/,
    /^https:\/\/api\.baykussinav\.com/
  ],
  // Session Replay
  replaysSessionSampleRate: 0.02, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 0.4 // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
})

const pinia = createPinia()
const vfm = createVfm()
app.directive('linkify', Linkify)
pinia.use(piniaPluginPersistedstate)
app.use(pinia)
app.use(router)
app.use(vfm)
app.use(VueQueryPlugin)
// @ts-ignore
app.use(VueAwesomePaginate)
AppReady.init()
app.mount('#app')
